import { render, staticRenderFns } from "./match-competition-pass.vue?vue&type=template&id=fa55788a&scoped=true"
import script from "./match-competition-pass.vue?vue&type=script&lang=js"
export * from "./match-competition-pass.vue?vue&type=script&lang=js"
import style0 from "./match-competition-pass.vue?vue&type=style&index=0&id=fa55788a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa55788a",
  null
  
)

export default component.exports